enum RecaptchaActions {
  SIGN_UP = 'signup',
  SIGN_IN = 'login',
  RESET_PASSWORD = 'password_update',
  SIGN_UP_EMAIL = 'signup'
}

export default RecaptchaActions;
